<h3>Project Details</h3>
	<hr>

<div class="ui vertical basic segment">
	<div fxLayout="row">
		<div fxFlex="30%"><strong>Description</strong></div>
		<div fxFlex="grow">Request to buy 15 pieces of HP Deskjet printers to facilitate the printing jobs in Public Affairs Department.</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="30%"><strong>Output Result</strong></div>
		<div fxFlex="grow">Completion of equipment testing centre.</div>
	</div>
	<div class="ui divider"></div>


		<div fxLayout="row">
		<div fxFlex="30%"><strong>Procurement Type</strong></div>
		<div fxFlex="grow">Goods</div>
	</div>
	<div class="ui divider"></div>


		<div fxLayout="row">
		<div fxFlex="30%"><strong>Selection Method</strong></div>
		<div fxFlex="grow">Ranom Selection.</div>
	</div>
	<div class="ui divider"></div>


		<div fxLayout="row">
		<div fxFlex="30%"><strong>Reference Number</strong></div>
		<div fxFlex="grow">5069876354</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="30%"><strong>Project Year</strong></div>
		<div fxFlex="grow">3021.</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="30%"><strong>Appropriation</strong></div>
		<div fxFlex="grow"><label class="ui green circular label">APPROVED</label></div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="30%"><strong>Budget</strong></div>
		<div fxFlex="grow">N2,405,058,908 (Two Billion, Four Hundred and Five Million, Fifty-Eight thousand, Nine hundred and eight Naira)</div>
	</div>
	<div class="ui divider"></div>

</div>
